import { useEffect } from "react";

export default function Timer({ timeLeft, setTimeLeft }) {
  useEffect(() => {
    if (timeLeft <= 0) return;

    const timer = setTimeout(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);

    return () => clearTimeout(timer);
  }, [timeLeft]);

  if (timeLeft <= 0) return null;

  return (
    <div className="text-danger small mb-2 text-center">
      Resend OTP in <b>{timeLeft}s</b>
    </div>
  );
}
